<template>
    <div>
        <el-menu default-active="1" class="el-menu-group" mode="horizontal" @select="handleSelect" >
            <el-menu-item index="1">数据大盘</el-menu-item>
            <el-menu-item index="3">产品数据</el-menu-item>
            <el-menu-item index="4">渠道数据</el-menu-item>
            <el-menu-item index="2">投诉数据</el-menu-item>
            <el-menu-item index="5">转化数据</el-menu-item>
        </el-menu>
        <div style='margin-top:30px'></div>
        <div class="line"></div>
        <v-content1 v-if="itemVal==1"></v-content1>
        <v-content3 v-if="itemVal==3"></v-content3>
        <v-content4 v-if="itemVal==4"></v-content4>
        <v-content2 v-if="itemVal==2"></v-content2>
        <v-content5 v-if="itemVal==5"></v-content5>
    </div>
</template>

<script>
import vContent1 from './DataBody1.vue';
import vContent3 from './DataBody5.vue';
import vContent4 from './DataBody6.vue';
import vContent2 from './DataTs1.vue';
import vContent5 from './DataBody4.vue';
export default {
    data() {
        return {
            itemVal:'1',
        }
    },
    components: { 
        vContent1,
        vContent2,
        vContent3,
        vContent4,
        vContent5
    },
    methods: {

        refresh(){
            history.go(0); 
        },
        //在线销户
        destoryPhone(){
            window.open("https://doc.weixin.qq.com/forms/AF0AYgdVAD0AVcA2QapACQnrOLkAlnRBf");
        },
        handleSelect(key, keyPath) {
            this.itemVal = key;
        },
    }
}
</script>
<style scoped>


</style>
